import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-14 sm:py-20 px-4" data-id="element-43">
      <div className="max-w-2xl mx-auto text-center" data-id="element-44">
        <h2 className="text-xl sm:text-3xl font-bold text-white mb-2" data-id="element-45">
          El próximo domingo podés seguir buscando en Google.
        </h2>
        <p className="text-[#FF6B00] text-2xl sm:text-4xl font-black mb-8" data-id="element-46">
          O tener todo resuelto desde hoy.
        </p>

        {/* Countdown */}
        <div className="mb-3" data-id="element-47">
          <CountdownTimer size="lg" blinking={true} data-id="element-48" />
        </div>
        <p className="text-gray-400 text-sm mb-8" data-id="element-49">
          Después sube <span className="text-[#FF0000] font-bold" data-id="element-50">$10.000</span>{' '}
          y no vuelve.
        </p>

        {/* Single CTA */}
        <a href="#pricing" className="btn-orange-pulse inline-block bg-[#FF6B00] text-white font-black text-lg sm:text-2xl px-10 sm:px-14 py-4 sm:py-5 rounded-xl hover:bg-orange-400 transition-colors shadow-[0_0_30px_rgba(255,107,0,0.3)] mb-5" data-id="element-51">
          🌟 ELEGÍ TU PROFEPACK →
        </a>

        {/* Trust */}
        <div className="flex items-center justify-center gap-2 sm:gap-4 text-[11px] sm:text-sm text-gray-400" data-id="element-52">
          <span data-id="element-53">🔒 Pago seguro</span>
          <span data-id="element-54">⚡ Acceso en 5 min</span>
          <span data-id="element-55">🛡️ Garantía 7 días</span>
          <span data-id="element-56">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}